const Header = () => (
    <div className="top-area">
        <div className="header-area">
            <nav className="navbar navbar-default bootsnav  navbar-sticky navbar-scrollspy" data-minus-value-desktop="70" data-minus-value-mobile="55" data-speed="1000">
                <div className="container">
                    <div className="navbar-header">
                        <button type="button" className="navbar-toggle" data-toggle="collapse" data-target="#navbar-menu">
                            <i className="fa fa-bars"></i>
                        </button>
                        <a className="navbar-brand" href="#home">CAR BLOG<span></span></a>
                    </div>
                    <div className="collapse navbar-collapse menu-ui-design" id="navbar-menu">
                        <ul className="nav navbar-nav navbar-right" data-in="fadeInDown" data-out="fadeOutUp">
                            <li className="scroll active"><a href="#home">Home</a></li>
                            <li className="scroll"><a href="#service">Service</a></li>
                            <li className="scroll"><a href="#featured-cars">Featured cars</a></li>
                            <li className="scroll"><a href="#new-cars">New Cars</a></li>
                            <li className="scroll"><a href="#brand">Brands</a></li>
                            <li className="scroll"><a href="#contact">Contact</a></li>
                        </ul>
                    </div>
                </div>
            </nav>
        </div>
    </div>
);

export default Header;
